import { useMemo } from "react";

export const FilterCategory = (props) => {
  const filterOptions = useMemo(() => {
    var newOptionState = [];

    for (let _i = 0; _i < props.filter.options.length; _i++) {
      const option = props.filter.options[_i];
      const id = "cb_" + props.filter.contentUId + "_" + option;
      if (
        props.ficheData?.categories?.indexOf(option) > -1 ||
        props.ficheData?.categories === undefined
      ) {
        newOptionState.push(
          <div key={props.filter.contentUId + "_" + _i}>
            <label htmlFor={id}>
              <input
                id={id}
                value={option}
                defaultChecked={false}
                type={"checkbox"}
                onChange={(evt) => {
                  if (evt.target.checked) {
                    props.filter.values.push(option);
                  } else {
                    props.filter.values = props.filter.values.filter(
                      (v) => v !== option
                    );
                  }
                  let newState = { ...props.ficheData };
                  props.setFicheData((prev) => {
                    return {
                      ...prev,
                      filter: newState.filter,
                    };
                  });
                }}
              />
              {option}
            </label>
          </div>
        );
      }
    }
    return newOptionState;
  }, [JSON.stringify(props.filter.options)]);

  return (
    <div
      className={`col-sm-${
        props.filter.gridWidth != 0 ? props.filter.gridWidth : 4
      }`}
    >
      <strong>{props.dictionary.theme}</strong>
      {filterOptions}
    </div>
  );
};
